import React from 'react';

function CatalogueSidebar({ filtersOpen, children }) {
  return (
    <div className="catalogue-sidebar">
      <div className={`catalogue-filters${filtersOpen ? ' open' : ''}`}>
        {children}
      </div>
    </div>
  );
}

export default CatalogueSidebar;
